import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const PageContainer = styled.div`
  width: 100%;
  height: 500px;
`;

export const TreeContainer = styled.div`
  background-color: ${COLOR.WHITE};
  border: 1px ${COLOR.ALUMINIUM};
  border-radius: 3px;
  width: 100%;
  height: 100%;

  & .react-flow__handle {
    border-color: ${COLOR.CHEMISTRY};
    background-color: ${COLOR.WHITE};
  }
  & .react-flow__attribution {
    display: none;
  }
`;
